const cardImages = [
  'https://cdn2.coachmag.co.uk/sites/coachmag/files/styles/16x9_480/public/2018/02/kettlebell-walking-lunge.jpg?itok=y9kfXQjw&timestamp=1518628727',
  'https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
  'https://www.planetfitness.com/sites/default/files/feature-image/break-workout_602724.jpg',
  'https://images.shape.mdpcdn.com/sites/shape.com/files/low-impact-workout-lunge.jpg',
  'https://www.runtastic.com/blog/wp-content/uploads/2018/08/thumbnail_1200x800-1-1024x683.jpg',
  'https://content.active.com/Assets/Active.com+Content+Site+Digital+Assets/Fitness/580x350/Push-Up.jpg',
];

export default cardImages;
